

















import { CheckIsMUZE } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

const IsMUZE = CheckIsMUZE();

@Component
export default class extends Vue {
  private show = false;
  private optionList = [
    {
      name: "ManualPEAKTax",
      icon: "far fa-file-alt",
      link:
        "https://intercom.help/peak/en/collections/3474326-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A-%E0%B8%87%E0%B8%B2%E0%B8%99-peak-%E0%B9%80%E0%B8%9E%E0%B8%B7-%E0%B8%AD%E0%B8%97%E0%B8%B3%E0%B8%A0%E0%B8%B2%E0%B8%A9%E0%B8%B5-peak-tax",
      isShow: !IsMUZE,
    },
    {
      name: "VideoUserManual",
      icon: "fas fa-play",
      link: "https://www.youtube.com/playlist?list=PLKx_LgGwE9YNaQBACHUHcDEpg3APZMNyS",
      isShow: true,
    },
  ];

  public hide() {
    this.show = false;
  }
}
